// Single top-of-page navbar. Visible on every screen — Landing, Dashboard,
// HatomNfts. The tab switcher (in App.tsx) renders directly underneath this.

import { AddressChip } from "./ui";

export default function Navbar({
  network,
  loggedInAddress,
  isOwner,
  onConnect,
  onDisconnect,
}: {
  network: string;
  loggedInAddress: string | null;
  isOwner: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
}) {
  return (
    <nav className="navbar">
      <div className="brand">
        esc<span className="accent">row</span>
        {loggedInAddress && isOwner && (
          <span className="badge" style={{ marginLeft: "0.5rem" }}>
            admin
          </span>
        )}
      </div>
      <div className="row">
        <span className={`badge ${network === "mainnet" ? "live" : "test"}`}>
          {network}
        </span>
        {loggedInAddress ? (
          <>
            <AddressChip address={loggedInAddress} network={network} label="you" />
            <button className="ghost" onClick={onDisconnect}>
              Disconnect
            </button>
          </>
        ) : (
          <button onClick={onConnect}>Connect wallet</button>
        )}
      </div>
    </nav>
  );
}
